const routes = {
  home: '/',
  dashboard: '/',
  onboarding: '/onboarding',
  settings: '/settings',
  insight: '/insight',
  notifications: '/settings/notifications',
  enableNotifications: '/enable-notifications',
  memories: '/memories',
  almi: '/almi',
  signIn: '/signin',
  createMoment: '/create',
  editMoment: (id: string) => `/moments/${id}/edit`,
  detailMoment: (id: string) => `/moments/${id}`,
}

export default routes
